import React from 'react';

export const Play = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M7.012 21.753a3.77 3.77 0 0 1-1.843-.488 3.705 3.705 0 0 1-1.919-3.271V6.006c0-1.375.717-2.597 1.919-3.27a3.72 3.72 0 0 1 3.807.072l10.076 6.166A3.524 3.524 0 0 1 20.75 12a3.525 3.525 0 0 1-1.698 3.026L8.976 21.192a3.76 3.76 0 0 1-1.964.561Zm0-18.003c-.38 0-.76.098-1.109.294A2.223 2.223 0 0 0 4.75 6.006v11.988c0 .824.43 1.558 1.152 1.962.724.406 1.58.391 2.29-.043l10.076-6.166c.614-.376.981-1.029.981-1.747 0-.718-.367-1.371-.981-1.747L8.193 4.087a2.266 2.266 0 0 0-1.181-.337Z"
      />
    </svg>
  );
};
